import React from 'react'
import { ComingSoon } from '@/components/common/ComingSoon'

const PeriodClosePage = () => {
  return (
    <ComingSoon 
      title="Period Close"
      description="Month-end closing workflow and controls"
    />
  )
}

export default PeriodClosePage
